import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';

export const useExperimentalShareMutation = (options?: {
	onCompleted?: (data: ExperimentalShareMutation) => void;
}) => {
	return useExperimentalMutation<
		ExperimentalShareMutation,
		ExperimentalShareMutationVariables,
		ExperimentalShareMutationResponse
	>({
		url: '/gateway/api/share',
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: (response) => ({
			experimentalShare: {
				status: String(response.status),
				success: Boolean(response.ok),
				__typename: 'ExperimentalShareResponse',
			},
		}),
		parseResponseOnSuccess: (response) => ({
			status: response.status,
			ok: response.ok,
		}),
		parseResponseOnError: (error) => {
			// Handle rate limiting errors from share service
			if ('response' in error && error.response?.status) {
				return {
					status: error.response.status,
					ok: false,
				};
			}
			throw error;
		},
		onCompleted: options?.onCompleted,
	});
};

interface ExperimentalShareMutation {
	experimentalShare: ExperimentalShare | null;
}

interface ExperimentalShare {
	status: string | null;
	success: boolean;
}

interface ExperimentalShareMutationVariables {
	requestBody: ExperimentalShareRequestBodyType;
}

interface ExperimentalShareRequestBodyType {
	content: ExperimentalShareRequestBodyContentType;
	recipients: ExperimentalShareRequestBodyUserOrGroupEntityList[];
	comment?: ExperimentalShareRequestBodyCommentType | null;
	metadata: ExperimentalShareRequestBodyMetadataType;
}

interface ExperimentalShareRequestBodyContentType {
	link: string;
	ari: string;
	title: string;
	type: string;
}

interface ExperimentalShareRequestBodyUserOrGroupEntityList {
	id: string;
	type: string;
}

interface ExperimentalShareRequestBodyCommentType {
	format: string;
	value: string;
}

interface ExperimentalShareRequestBodyMetadataType {
	productId: string;
	atlOriginId: string;
	shareeAction?: string | null;
}

interface ExperimentalShareMutationResponse {
	status: number;
	ok: boolean;
}
